import { useOutletContext } from "react-router-dom";

import { getPlatformWorkspace } from "../../utils/platformWorkspace";

export default function PlatformWorkspacePage({ managed: ManagedPage, onPrem: OnPremPage }) {
  const { sessionProfile } = useOutletContext();
  const workspace = getPlatformWorkspace(sessionProfile);

  if (workspace === "onprem" && OnPremPage) return <OnPremPage />;
  if (workspace === "managed" && ManagedPage) return <ManagedPage />;
  return null;
}
